import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NgxSpinner, NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { Observable, Subject, takeUntil } from 'rxjs';
import { BlogTags } from '../../_shared/_enums/blog-tags';
import { SEO } from '@app/_shared/_models';
import { BlogService } from '../../_shared/_services/blog.service';
import { ProductService } from '../../_shared/_services/product.service';
import { SeoService } from '../../_shared/_services/seo.service';
import { IBlogPost } from '../_prismic/blog-post';
import { ImageComponent } from '../../_shared/_components/image/image.component';
import { ShopByBrandComponent } from '../../_shared/_components/shop-by-brand/shop-by-brand.component';
import { AsyncPipe, UpperCasePipe, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-my-pool-hut-opening-announcement',
    templateUrl: './my-pool-hut-opening-announcement.component.html',
    styleUrls: ['./my-pool-hut-opening-announcement.component.scss'],
    imports: [NgxSpinnerComponent, ImageComponent, ShopByBrandComponent, RouterLink, AsyncPipe, UpperCasePipe, DatePipe]
})
export class MyPoolHutOpeningAnnouncementComponent implements OnInit, OnDestroy {
  private readonly blogService = inject(BlogService);
  private readonly ngxSpinnerService = inject(NgxSpinnerService);
  private readonly productService = inject(ProductService);
  private readonly seoService = inject(SeoService);

  public seo: SEO = {
    image: 'https://mypoolhut.com/assets/images/WomenInPoolWithLogoReverse.jpg',
    metaDescription: 'New E-Commerce Store My Pool Hut is Online and Selling High Quality Pool and Hot Tub Care Products',
    metaTitle: 'My Pool Hut Opens E-Commerce Store for the 2023 Pool Season'
  };
  public spinner$: Observable<NgxSpinner>;
  public blogPost!: IBlogPost;
  private readonly blogTags = BlogTags;
  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  constructor() {
    const ngxSpinnerService = this.ngxSpinnerService;

    this.spinner$ = ngxSpinnerService.spinnerObservable;
  }

  public async ngOnInit(): Promise<void> {
    this.seoService.setMetaData(this.seo);
    this.seoService.createCanonicalUrl('https://mypoolhut.com/blog/my-pool-hut-opening-announcement');

    await this.ngxSpinnerService.show();
    this.blogService.blogs$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(async (blogs: Array<IBlogPost>) => {
        const index = blogs.findIndex(b => b.tag === this.blogTags.MY_POOL_HUT_OPENING_ANNOUNCEMENT);
        if (index > -1) {
          this.blogPost = blogs[index];
          await this.ngxSpinnerService.hide();
        } else {
          await this.blogService.loadBlogs();
        }
      });

  }

  public ngOnDestroy(): void {
    this.seoService.removeCanonicalUrl();
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
